import { useContext, useEffect, useState, useRef } from 'react';
import Spinner from '../components/spinners/Spinner';

import { Card, CardHeader, CardBody, CardTitle, Row, Col } from "reactstrap";

import styled from 'styled-components';
import AuthContext from '../context/autenticacion/authContext.js';
import { Link } from 'react-router-dom';
import { useT } from 'i18n';

// aqui solo aparece el responsive pequenho
const DivMobile = styled.div`
  padding: 0rem !important;
  margin: 0.2rem 0rem 2.0rem 0rem !important;
  display: flex !important;
  flex-direction: row;
  justify-content: center;

  @media(min-width: 992px) {
    display: none !important;
    justify-content: center;
  }
`;

// pantalla grande
const Divdesktop = styled.div`
  display: none !important;

  @media(min-width: 992px) {
    display: block !important;
  }
`;

const UltimosMov = ({ ApiLoad, apiload }) => {
  const { t } = useT();

  
  // 🔑 Flag para evitar múltiples llamadas
  const hasLoaded = useRef(false);
  const isFetching = useRef(false);


  const authContext = useContext(AuthContext);
  const { 
    ultimos_movimientos, 
    Movimientos, 
    CerrarSesion,
    saldos 
  } = authContext;

  const [cargando, guardarCargando] = useState(false);
  const [balance, guardarBalance] = useState([]);
  const [cantidad, guardarCantidades] = useState(0);

  // 🔑 Función para cargar movimientos (solo una vez)
  const cargarMovimientos = async () => {
    // Evitar múltiples llamadas simultáneas
    if (isFetching.current) {
      console.log('🚫 Ya hay una petición en curso, ignorando...');
      return;
    }
    
    // Evitar recargar si ya se cargaron
    if (hasLoaded.current) {
      console.log('🚫 Los movimientos ya se cargaron, ignorando...');
      return;
    }
    
    isFetching.current = true;
    guardarCargando(true);
    
    try {
      if (Movimientos) {
        await Movimientos();
        hasLoaded.current = true;
        console.log('✅ Movimientos cargados exitosamente');
      }
    } catch (error) {
      console.error('❌ Error cargando movimientos:', error);
      if (error.response?.status === 401) {
        CerrarSesion();
      }
    } finally {
      guardarCargando(false);
      isFetching.current = false;
    }
  };

  // 🔑 Cargar movimientos SOLO UNA VEZ al montar el componente
  useEffect(() => {
    cargarMovimientos();
  }, []); // ← Dependencias vacías = solo se ejecuta una vez

  // 🔑 Actualizar la lista cuando cambien los movimientos en el contexto
  useEffect(() => {
    if (ultimos_movimientos && ultimos_movimientos.length > 0) {
      guardarBalance(ultimos_movimientos);
      guardarCantidades(ultimos_movimientos.length);
    }
  }, [ultimos_movimientos]);

  // Mostrar mensaje de carga solo la primera vez
  if (cargando && !hasLoaded.current) {
    return (
      <Col sm="12" xl="12" lg="12" md="12" className="height-fix-productos-inversion">
        <Card>
          <CardBody className="d-flex justify-content-center">
            <div className="text-center p-5">
              <Spinner />
              <p className="mt-2">{t('movs.ultCargando')}</p>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }

  return (
    <>
      <div timeout={1200}>
        {cantidad > 0 ? (
          <Col sm="12" xl="12" lg="12" md="12">
            <Divdesktop>
              <Card className="height-fix-ultimos-movimientos justify-content-center">
                <div>
                  <CardHeader>
                    <CardTitle tag="h2" className="card-title-fix">{t('movs.ultTituloD')}</CardTitle>
                    <p>
                      <small className="fix-mov-title">
                        {t('movs.ultResumen', { n: cantidad })}
                      </small>
                    </p>
                    <Link to="/cliente/movimientos" className="p7-link-todos">{t('movs.verTodos')}</Link>
                  </CardHeader>

                  <CardBody className="header-inversiones-grid movimientos-box-grid">
                    <div className="grid-container-tabla-movimientos">
                      <div data-tooltip={t('movs.tipFecha')}>
                        <strong className="line-fix">
                          <i className="tim-icons icon-calendar-60 p-2" /> {t('movs.hFecha')}
                        </strong>
                      </div>
                      <div data-tooltip={t('movs.tipReferencia')}>
                        <strong className="line-fix">
                          <i className="tim-icons icon-puzzle-10 p-2" /> {t('movs.hReferencia')}
                        </strong>
                      </div>
                      <div data-tooltip={t('movs.tipDetalle')}>
                        <strong className="line-fix">
                          <i className="tim-icons icon-paper p-2" /> {t('movs.hDescripcion')}
                        </strong>
                      </div>
                      <div data-tooltip={t('movs.tipMonto')}>
                        <strong className="line-fix text-right align-items-flex-end">
                          <i className="tim-icons icon-coins p-2" /> {t('movs.hMonto')}
                        </strong>
                      </div>
                      <div data-tooltip={t('movs.tipSaldo')}>
                        <strong className="line-fix text-right align-items-flex-end">
                          <i className="tim-icons icon-bank p-2" /> {t('movs.hSaldo')}
                        </strong>
                      </div>
                    </div>
                  </CardBody>

                  {balance.slice(0, 5).map(balances => (
                    <CardBody className="header-inversiones-grid movimientos-box-grid-body animation-cuentas" key={balances.id}>
                      <div className="grid-container-tabla-movimientos animation-op">
                        <div>
                          <strong className="line-fix">{balances.fecha_registro}</strong>
                        </div>
                        <div>
                          <strong className="line-fix">
                            {balances.code === null ? '000000' : balances.code}
                          </strong>
                        </div>
                        <div>
                          <strong className="line-fix text-left p7-mov-desc" title={balances.description}>{balances.description}</strong>
                        </div>
                        <div className={parseFloat(balances.balance) < 0 ? 'saldos-neg' : 'saldos-plus'}>
                          <strong className="line-fix text-right align-items-flex-end">{balances.balance}</strong>
                        </div>
                        <div>
                          <strong className="line-fix text-right align-items-flex-end">{balances.saldo}</strong>
                        </div>
                      </div>
                    </CardBody>
                  ))}
                </div>
              </Card>
            </Divdesktop>

            <DivMobile>
              <Card className="height-fix-ultimos-movimientos justify-content-center table-responsive">
                <div>
                  <div className="box-grid-header">
                    <div className="elemento1-mov-header">
                      <h2 className="w-100 text-center">{t('movs.ultTituloM')}</h2>
                      <p>{t('movs.ultResumen', { n: cantidad })}</p>
                    </div>
                    <div className="elemento2-mov-header">
                      <Link to="/cliente/movimientos" className="p7-link-todos">{t('movs.verTodos')}</Link>
                    </div>
                  </div>

                  <div className="box-grid">
                    <div className="box-grid-son">
                      {balance.slice(0, 5).map(balances => (
                        <div className="ultimos-grid-movimientos animation-cuentas" key={balances.id}>
                          <div className="elemento1-mov">
                            <div>
                              <i className="tim-icons icon-calendar-60 p-2" />
                              <p>
                                <strong>{t('movs.lFecha')}</strong>
                                <br />
                                {balances.fecha_registro}
                              </p>
                            </div>
                            <div>
                              <i className="tim-icons icon-puzzle-10 p-2" />
                              <p>
                                <strong>{t('movs.lReferencia')}</strong>
                                <br />
                                {balances.code === null ? '000000' : balances.code}
                              </p>
                            </div>
                          </div>
                          <div className="elemento2-mov">
                            <div>
                              <i className="tim-icons icon-coins p-2" />
                              <p>
                                <strong className="line-fix">{t('movs.lMonto')}</strong>
                                <br />
                                <span className={parseFloat(balances.balance) < 0 ? 'saldos-neg' : 'saldos-plus'}>
                                  {balances.balance}
                                </span>
                              </p>
                            </div>
                            <div>
                              <i className="tim-icons icon-bank p-2" />
                              <p>
                                <strong>{t('movs.lSaldo')}</strong>
                                <br /> {balances.saldo}
                              </p>
                            </div>
                          </div>
                          <div className="elemento3-mov">
                            <div>
                              <i className="tim-icons icon-badge p-2" />
                              <p>
                                <strong>{t('movs.lDescripcion')}</strong>
                                <br /> {balances.description}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </Card>
            </DivMobile>
          </Col>
        ) : (
          <Col sm="12" xl="12" lg="12" md="12" className="height-fix-productos-inversion">
            <Card>
              <div>
                <CardBody className="d-flex justify-content-center">
                  <Row className="box-depositos-seleccion-alerta justify-content-center col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <Col md="12" className="panther-open-titulo-alerta border-panther">
                      {cantidad === 0 && !cargando ? (
                        <>
                          <i className="tim-icons icon-spaceship animation-icon-in mb-1" />
                          <h2 className="animation-icon-in-dos mb-4">{t('movs.vacioTitulo')}</h2>
                          <h3 className="animate-raya-03 mb-2">{t('movs.vacioMsg')}</h3>
                          <p className="text-center animation-icon-in-cuatro">{t('movs.vacioPie')}</p>
                        </>
                      ) : (
                        <Spinner />
                      )}
                    </Col>
                  </Row>
                </CardBody>
              </div>
            </Card>
          </Col>
        )}
      </div>

    </>
  );
};

export default UltimosMov;